@if (isLoading) {
  <app-loader></app-loader>
}

@if (!isLoading) {
  <div class="main-wrapper">
    <router-outlet></router-outlet>
  </div>
}
